import React, { useState } from 'react'
import WorkerFilterBtn from '../../assets/Images/Worker-modal-01.png'
import WorkerFilterBtn2 from '../../assets/Images/Worker-modal-02.png'
import WorkerFilterBtn3 from '../../assets/Images/Worker-modal-03.png'
import WorkerFilterBtn4 from '../../assets/Images/Worker-modal-04.png'
import WorkerFilterBtn5 from '../../assets/Images/Worker-modal-05.png'


const ShareModalTabs = () => {
     const [selectedWorkerModalType, setSelectedWorkerModalType] = useState("WorkerModal");
  return (
    
    <div className="modal fade select-worker-modal-sec" id="shareModal"  tabIndex={-1} aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
                {/* <div className="modal-header d-flex align-items-center justify-content-between gap-2">
                    <h1>Select Worker</h1>
                    <button type="button" className="btn-close"  data-bs-dismiss="modal"  aria-label="Close" >
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="32" height="32" rx="16" fill="#F1F1F1"/><path d="M22.3007 9.70997C21.9107 9.31997 21.2807 9.31997 20.8907 9.70997L16.0007 14.59L11.1107 9.69997C10.7207 9.30997 10.0907 9.30997 9.7007 9.69997C9.3107 10.09 9.3107 10.72 9.7007 11.11L14.5907 16L9.7007 20.89C9.3107 21.28 9.3107 21.91 9.7007 22.3C10.0907 22.69 10.7207 22.69 11.1107 22.3L16.0007 17.41L20.8907 22.3C21.2807 22.69 21.9107 22.69 22.3007 22.3C22.6907 21.91 22.6907 21.28 22.3007 20.89L17.4107 16L22.3007 11.11C22.6807 10.73 22.6807 10.09 22.3007 9.70997Z" fill="#301E39"/></svg>
                    </button>
                </div> */}
                <div className="modal-body">
                    <div className='search-box'>
                        <form action="">
                            <div className='from-group position-relative'>
                                <input type="text" placeholder='Search worker' />
                                <button type='button'>
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_147_4437)"><ellipse cx="9.80898" cy="9.62343" rx="6.475" ry="6.47499" stroke="#301E39" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.83398 8.98177C5.83398 7.14082 7.32637 5.64844 9.16732 5.64844" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M14.2598 14.4019L17.4999 17.642" stroke="#301E39" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_147_4437"><rect width="20" height="20" fill="white"/></clipPath></defs></svg>
                                </button>
                            </div>
                        </form>
                    </div>
                    <div className='worker-fileter-sec'>
                        <div className='worker-box d-flex align-items-center justify-content-between gap-2 mb-3'>
                            <div className='left-box d-flex align-items-center gap-2'>
                                <div className='img-box'>
                                    <img src={WorkerFilterBtn} alt="" />
                                </div>
                                <div className='text-box'>
                                    <h6>@iamtom</h6>
                                </div>
                            </div>
                            <div className='right-box'>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="WorkerModal" id="WorkerModal" value="WorkerModal" checked={selectedWorkerModalType === "WorkerModal"} onChange={() => setSelectedWorkerModalType("WorkerModal")} />
                                    <label className="form-check-label" htmlFor="WorkerModal"></label>
                                </div>
                            </div>
                        </div>
                        <div className='worker-box d-flex align-items-center justify-content-between gap-2 mb-3'>
                            <div className='left-box d-flex align-items-center gap-2'>
                                <div className='img-box'>
                                    <img src={WorkerFilterBtn2} alt="" />
                                </div>
                                <div className='text-box'>
                                    <h6>@iamtom</h6>
                                </div>
                            </div>
                            <div className='right-box'>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="Service1" id="Service1" value="Service1" checked={selectedWorkerModalType === "Service1"} onChange={() => setSelectedWorkerModalType("Service1")} />
                                    <label className="form-check-label" htmlFor="Service1"></label>
                                </div>
                            </div>
                        </div>
                        <div className='worker-box d-flex align-items-center justify-content-between gap-2 mb-3'>
                            <div className='left-box d-flex align-items-center gap-2'>
                                <div className='img-box'>
                                    <img src={WorkerFilterBtn3} alt="" />
                                </div>
                                <div className='text-box'>
                                    <h6>@iamtom</h6>
                                </div>
                            </div>
                            <div className='right-box'>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="Service2" id="Service2" value="Service2" checked={selectedWorkerModalType === "Service2"} onChange={() => setSelectedWorkerModalType("Service2")} />
                                    <label className="form-check-label" htmlFor="Service2"></label>
                                </div>
                            </div>
                        </div>
                        <div className='worker-box d-flex align-items-center justify-content-between gap-2 mb-3'>
                            <div className='left-box d-flex align-items-center gap-2'>
                                <div className='img-box'>
                                    <img src={WorkerFilterBtn4} alt="" />
                                </div>
                                <div className='text-box'>
                                    <h6>@iamtom</h6>
                                </div>
                            </div>
                            <div className='right-box'>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="Service3" id="Service3" value="Service3" checked={selectedWorkerModalType === "Service3"} onChange={() => setSelectedWorkerModalType("Service3")} />
                                    <label className="form-check-label" htmlFor="Service3"></label>
                                </div>
                            </div>
                        </div>
                        <div className='worker-box d-flex align-items-center justify-content-between gap-2 mb-3'>
                            <div className='left-box d-flex align-items-center gap-2'>
                                <div className='img-box'>
                                    <img src={WorkerFilterBtn5} alt="" />
                                </div>
                                <div className='text-box'>
                                    <h6>@iamtom</h6>
                                </div>
                            </div>
                            <div className='right-box'>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="Service4" id="Service4" value="Service4" checked={selectedWorkerModalType === "Service4"} onChange={() => setSelectedWorkerModalType("Service4")} />
                                    <label className="form-check-label" htmlFor="Service4"></label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer justify-content-between d-flex align-items-center">
                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal"> Cancel </button>
                    <button type="button" className="btn btn-primary"> Send </button>
                </div>
            </div>
        </div>
    </div>

  )
}

export default ShareModalTabs
